(function(){
  var cartCount = document.getElementById('cartCount');
  var toast = document.getElementById('toast'), toastMsg = document.getElementById('toastMsg');
  var tt;

  function showToast(msg){
    toastMsg.textContent = msg;
    toast.classList.add('show');
    clearTimeout(tt);
    tt = setTimeout(function(){ toast.classList.remove('show'); }, 2400);
  }

  function bumpCount(count){
    if (!cartCount) return;
    cartCount.textContent = count;
    if (cartCount.animate) {
      cartCount.animate([{ transform: 'scale(1.5)' }, { transform: 'scale(1)' }], { duration: 280, easing: 'ease-out' });
    }
  }

  document.body.addEventListener('click', function(e){
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    var name = btn.getAttribute('data-name') || 'Item';
    if (!variantId) return;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = '...';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(res){ if (!res.ok) throw new Error('add failed'); return fetch('/cart.js'); })
    .then(function(res){ return res.json(); })
    .then(function(cart){
      bumpCount(cart.item_count);
      showToast(name + ' added to cart!');
    })
    .catch(function(){
      showToast('Could not add that item — please try again.');
    })
    .finally(function(){
      btn.disabled = false;
      btn.textContent = originalText;
    });
  });

  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn) {
    cartBtn.addEventListener('click', function(){
      // Native link to /cart handles navigation; nothing else needed.
    });
  }

  var searchToggle = document.getElementById('searchToggle');
  var searchInput = document.getElementById('searchInput');
  if (searchToggle && searchInput) {
    searchToggle.addEventListener('click', function(){
      searchInput.classList.toggle('show');
      if (searchInput.classList.contains('show')) searchInput.focus();
    });
  }

  var burger = document.getElementById('burger');
  var mobileNav = document.getElementById('mobileNav');
  var mobileNavOverlay = document.getElementById('mobileNavOverlay');
  function closeMobileNav(){
    if (!mobileNav) return;
    mobileNav.classList.remove('show');
    mobileNavOverlay.classList.remove('show');
    burger.setAttribute('aria-expanded', 'false');
  }
  if (burger && mobileNav) {
    burger.addEventListener('click', function(){
      var open = mobileNav.classList.toggle('show');
      mobileNavOverlay.classList.toggle('show', open);
      burger.setAttribute('aria-expanded', String(open));
    });
    mobileNavOverlay.addEventListener('click', closeMobileNav);
    mobileNav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMobileNav); });
  }

  function updatePdpPrice(slide){
    if (!slide) return;
    var priceEur = slide.getAttribute('data-price-eur');
    if (priceEur === null || priceEur === '') return;
    var priceFormatted = slide.getAttribute('data-price-formatted');
    var priceEl = document.querySelector('.pdp-copy .price-row .price');
    if (!priceEl) return;
    var currency = document.documentElement.getAttribute('data-active-currency') || 'EUR';
    var symbols = { EUR: '€', USD: '$', GBP: '£', CHF: 'Fr', CAD: 'C$', AUD: 'A$' };
    var rates = null;
    try { var cached = JSON.parse(localStorage.getItem('ccRates') || 'null'); if (cached && cached.rates) rates = cached.rates; } catch (e) {}
    priceEl.setAttribute('data-price-eur', priceEur);
    priceEl.removeAttribute('data-price-original');
    if (currency && currency !== 'EUR') {
      var rate = (rates && rates[currency]) || 1;
      priceEl.textContent = (symbols[currency] || (currency + ' ')) + (parseFloat(priceEur) * rate).toFixed(2);
    } else {
      priceEl.textContent = priceFormatted;
    }
    var wasEl = document.querySelector('.pdp-copy .price-row .price-was');
    var badgeEl = document.querySelector('.pdp-copy .price-row .pdp-discount-badge');
    var compareEur = slide.getAttribute('data-compare-eur');
    var compareFormatted = slide.getAttribute('data-compare-formatted');
    var hasDiscount = compareEur && parseFloat(compareEur) > parseFloat(priceEur);
    if (wasEl) {
      if (hasDiscount) {
        wasEl.style.display = '';
        wasEl.setAttribute('data-price-eur', compareEur);
        wasEl.removeAttribute('data-price-original');
        if (currency && currency !== 'EUR') {
          var wasRate = (rates && rates[currency]) || 1;
          wasEl.textContent = (symbols[currency] || (currency + ' ')) + (parseFloat(compareEur) * wasRate).toFixed(2);
        } else {
          wasEl.textContent = compareFormatted;
        }
      } else {
        wasEl.style.display = 'none';
      }
    }
    if (badgeEl) badgeEl.style.display = hasDiscount ? '' : 'none';
  }

  document.body.addEventListener('click', function(e){
    var arrow = e.target.closest('.pdp-arrow');
    var dot = e.target.closest('.pdp-dot');
    if (!arrow && !dot) return;
    var mediaBlock = e.target.closest('.pdp-media');
    if (!mediaBlock) return;
    var gallery = mediaBlock.querySelector('.pdp-gallery');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('.pdp-slide');
    var dots = mediaBlock.querySelectorAll('.pdp-dot');
    var current = 0;
    slides.forEach(function(s, i){ if (s.classList.contains('active')) current = i; });
    var next = current;
    if (arrow) {
      next = arrow.classList.contains('next') ? current + 1 : current - 1;
    } else if (dot) {
      next = Array.prototype.indexOf.call(dots, dot);
    }
    next = ((next % slides.length) + slides.length) % slides.length;
    slides.forEach(function(s, i){ s.classList.toggle('active', i === next); });
    dots.forEach(function(d, i){ d.classList.toggle('active', i === next); });
    updatePdpPrice(slides[next]);
  });

  document.querySelectorAll('.pdp-gallery[data-gallery]').forEach(function(gallery){
    gallery.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', function(e){
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var mediaBlock = gallery.closest('.pdp-media');
      var slides = gallery.querySelectorAll('.pdp-slide');
      var dots = mediaBlock ? mediaBlock.querySelectorAll('.pdp-dot') : [];
      var current = 0;
      slides.forEach(function(s, i){ if (s.classList.contains('active')) current = i; });
      var next = e.key === 'ArrowLeft' ? current - 1 : current + 1;
      next = ((next % slides.length) + slides.length) % slides.length;
      slides.forEach(function(s, i){ s.classList.toggle('active', i === next); });
      dots.forEach(function(d, i){ d.classList.toggle('active', i === next); });
      updatePdpPrice(slides[next]);
    });
  });

  document.querySelectorAll('.rev-breakdown').forEach(function(breakdown){
    var section = breakdown.closest('.prod-reviews');
    if (!section) return;
    var track = section.querySelector('.rev-track');
    var rows = breakdown.querySelectorAll('.rev-bd-row');
    var resetBtn = breakdown.querySelector('.rev-bd-reset');
    var emptyMsg = breakdown.querySelector('.rev-bd-empty');
    function applyFilter(rating){
      var cards = section.querySelectorAll('.rev');
      var anyVisible = false;
      cards.forEach(function(card){
        if (!rating) { card.style.display = ''; return; }
        var match = card.getAttribute('data-rating') === String(rating);
        card.style.display = match ? '' : 'none';
        if (match) anyVisible = true;
      });
      if (track) track.classList.toggle('filtered', !!rating);
      rows.forEach(function(r){ r.classList.toggle('active', r.getAttribute('data-filter-rating') === String(rating)); });
      if (resetBtn) resetBtn.hidden = !rating;
      if (emptyMsg) emptyMsg.style.display = (rating && !anyVisible) ? 'block' : 'none';
    }
    rows.forEach(function(row){
      row.addEventListener('click', function(){
        var isActive = row.classList.contains('active');
        applyFilter(isActive ? null : row.getAttribute('data-filter-rating'));
      });
    });
    if (resetBtn) resetBtn.addEventListener('click', function(){ applyFilter(null); });
  });

  var revWriteStarsEl = document.getElementById('revWriteStars');
  var revWriteRatingInput = document.getElementById('revWriteRating');
  if (revWriteStarsEl && revWriteRatingInput) {
    var revWriteStarBtns = revWriteStarsEl.querySelectorAll('.rev-write-star');
    var paintRevStars = function(n){
      revWriteStarBtns.forEach(function(b){
        var v = parseInt(b.getAttribute('data-star'), 10);
        b.classList.toggle('filled', v <= n);
      });
    };
    revWriteStarBtns.forEach(function(b){
      b.addEventListener('click', function(){
        var v = parseInt(b.getAttribute('data-star'), 10);
        revWriteRatingInput.value = v;
        paintRevStars(v);
      });
      b.addEventListener('mouseenter', function(){
        paintRevStars(parseInt(b.getAttribute('data-star'), 10));
      });
    });
    revWriteStarsEl.addEventListener('mouseleave', function(){
      paintRevStars(parseInt(revWriteRatingInput.value, 10) || 0);
    });
  }

  var revWriteForm = document.querySelector('.rev-write-form');
  if (revWriteForm) {
    revWriteForm.addEventListener('submit', function(e){
      e.preventDefault();
      var ratingVal = revWriteRatingInput ? revWriteRatingInput.value : '';
      if (!ratingVal) {
        showToast('Please choose a star rating.');
        return;
      }
      var submitBtn = revWriteForm.querySelector('button[type="submit"]');
      var originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      fetch(revWriteForm.action, { method: 'POST', body: new FormData(revWriteForm) })
        .then(function(res){
          if (!res.ok) throw new Error('failed');
          showToast('Thanks! Your review has been submitted for approval.');
          revWriteForm.reset();
          if (revWriteRatingInput) revWriteRatingInput.value = '';
          if (revWriteStarsEl) revWriteStarsEl.querySelectorAll('.rev-write-star').forEach(function(b){ b.classList.remove('filled'); });
        })
        .catch(function(){
          showToast('Could not submit your review — please try again.');
        })
        .finally(function(){
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        });
    });
  }

  function updateCardPricing(card, slide){
    if (!card || !slide) return;
    var priceEur = slide.getAttribute('data-price-eur');
    var priceFormatted = slide.getAttribute('data-price-formatted');
    var priceEl = card.querySelector('.price');
    var currency = document.documentElement.getAttribute('data-active-currency') || 'EUR';
    var symbols = { EUR: '€', USD: '$', GBP: '£', CHF: 'Fr', CAD: 'C$', AUD: 'A$' };
    var rates = null;
    try { var cached = JSON.parse(localStorage.getItem('ccRates') || 'null'); if (cached && cached.rates) rates = cached.rates; } catch (e) {}
    if (priceEl && priceEur) {
      priceEl.setAttribute('data-price-eur', priceEur);
      priceEl.removeAttribute('data-price-original');
      if (currency && currency !== 'EUR') {
        var rate = (rates && rates[currency]) || 1;
        priceEl.textContent = (symbols[currency] || (currency + ' ')) + (parseFloat(priceEur) * rate).toFixed(2);
      } else {
        priceEl.textContent = priceFormatted;
      }
    }
    var wasEl = card.querySelector('.price-was');
    var compareEur = slide.getAttribute('data-compare-eur');
    var compareFormatted = slide.getAttribute('data-compare-formatted');
    if (wasEl) {
      if (compareEur && parseFloat(compareEur) > parseFloat(priceEur)) {
        wasEl.removeAttribute('style');
        wasEl.setAttribute('data-price-eur', compareEur);
        wasEl.removeAttribute('data-price-original');
        if (currency && currency !== 'EUR') {
          var wasRate = (rates && rates[currency]) || 1;
          wasEl.textContent = (symbols[currency] || (currency + ' ')) + (parseFloat(compareEur) * wasRate).toFixed(2);
        } else {
          wasEl.textContent = compareFormatted;
        }
      } else {
        wasEl.style.display = 'none';
      }
    }
    var addBtn = card.querySelector('[data-quick-add]');
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', slide.getAttribute('data-variant-id'));
      var available = slide.getAttribute('data-available') === 'true';
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Add' : 'Sold out';
      addBtn.style.opacity = available ? '' : '.55';
      addBtn.style.cursor = available ? '' : 'not-allowed';
    }
  }

  function stepCardSlide(media, dir){
    var slides = media.querySelectorAll('.card-slide');
    if (!slides.length) return;
    var current = 0;
    slides.forEach(function(s, i){ if (s.classList.contains('active')) current = i; });
    var next = dir === 'next' ? current + 1 : current - 1;
    next = ((next % slides.length) + slides.length) % slides.length;
    slides.forEach(function(s, i){ s.classList.toggle('active', i === next); });
    var card = media.closest('.card');
    updateCardPricing(card, slides[next]);
  }

  document.body.addEventListener('click', function(e){
    var cardArrow = e.target.closest('.card-arrow');
    if (!cardArrow) return;
    e.preventDefault();
    e.stopPropagation();
    var media = cardArrow.closest('[data-card-media]');
    if (!media) return;
    stepCardSlide(media, cardArrow.classList.contains('next') ? 'next' : 'prev');
  });

  (function(){
    var touchStartX = 0, touchStartY = 0, touchTarget = null;
    document.addEventListener('touchstart', function(e){
      var media = e.target.closest('[data-card-media]');
      if (!media) { touchTarget = null; return; }
      touchTarget = media;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function(e){
      if (!touchTarget) return;
      var media = touchTarget;
      touchTarget = null;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
      stepCardSlide(media, dx < 0 ? 'next' : 'prev');
    }, { passive: true });
  })();

  var CC_SYMBOLS = { EUR: '€', USD: '$', GBP: '£', CHF: 'Fr', CAD: 'C$', AUD: 'A$' };
  var CC_SUPPORTED = ['EUR', 'USD', 'GBP', 'CHF', 'CAD', 'AUD'];

  function ccFormat(amountEur, currency, rates) {
    var rate = currency === 'EUR' ? 1 : ((rates && rates[currency]) || 1);
    var val = amountEur * rate;
    var symbol = CC_SYMBOLS[currency] || (currency + ' ');
    return symbol + val.toFixed(2);
  }

  function ccApply(currency, rates) {
    document.querySelectorAll('[data-price-eur]').forEach(function(el){
      var eur = parseFloat(el.getAttribute('data-price-eur'));
      if (isNaN(eur)) return;
      if (!el.hasAttribute('data-price-original')) el.setAttribute('data-price-original', el.textContent);
      el.textContent = currency === 'EUR' ? el.getAttribute('data-price-original') : ccFormat(eur, currency, rates);
    });
    document.documentElement.setAttribute('data-active-currency', currency);
  }

  document.documentElement.setAttribute('data-active-currency', 'EUR');

  var ccRatesCache = null;
  try {
    var cachedRates = JSON.parse(localStorage.getItem('ccRates') || 'null');
    if (cachedRates && cachedRates.ts && (Date.now() - cachedRates.ts) < 3600000) { ccRatesCache = cachedRates.rates; }
  } catch (e) {}

  function ccSetCurrency(currency, persist) {
    if (persist) { try { localStorage.setItem('ccCurrency', currency); } catch (e) {} }
    if (currency === 'EUR' || ccRatesCache) { ccApply(currency, ccRatesCache); return; }
    fetch('https://open.er-api.com/v6/latest/EUR')
      .then(function(res){ return res.json(); })
      .then(function(data){
        ccRatesCache = data.rates;
        try { localStorage.setItem('ccRates', JSON.stringify({ ts: Date.now(), rates: ccRatesCache })); } catch (e) {}
        ccApply(currency, ccRatesCache);
      })
      .catch(function(){ /* keep EUR prices if the rate lookup fails */ });
  }

  var savedCurrency = null;
  try { savedCurrency = localStorage.getItem('ccCurrency'); } catch (e) {}
  if (savedCurrency && CC_SUPPORTED.indexOf(savedCurrency) !== -1) {
    ccSetCurrency(savedCurrency, false);
  } else {
    fetch('https://ipapi.co/currency/')
      .then(function(res){ return res.text(); })
      .then(function(code){
        code = (code || '').trim().toUpperCase();
        if (CC_SUPPORTED.indexOf(code) !== -1 && code !== 'EUR') {
          ccSetCurrency(code, true);
        }
      })
      .catch(function(){ /* stay on EUR if geolocation lookup fails */ });
  }

  document.body.addEventListener('click', function(e){
    var minus = e.target.closest('.pdp-qty-minus');
    var plus = e.target.closest('.pdp-qty-plus');
    if (!minus && !plus) return;
    var wrap = e.target.closest('.pdp-qty');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var val = parseInt(input.value, 10) || 0;
    input.value = plus ? val + 1 : Math.max(min, val - 1);
  });

  var pdpAddMultiple = document.getElementById('pdpAddMultiple');
  if (pdpAddMultiple) {
    pdpAddMultiple.addEventListener('click', function(){
      var rows = document.querySelectorAll('.pdp-variant-row');
      var items = [];
      rows.forEach(function(row){
        var qtyInput = row.querySelector('.pdp-variant-qty');
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 0) : 0;
        if (qty > 0) {
          items.push({ id: parseInt(row.getAttribute('data-variant-id'), 10), quantity: qty });
        }
      });
      if (!items.length) {
        showToast('Choose a quantity for at least one option.');
        return;
      }
      pdpAddMultiple.disabled = true;
      var originalText = pdpAddMultiple.textContent;
      pdpAddMultiple.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res){ if (!res.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function(res){ return res.json(); })
      .then(function(cart){
        bumpCount(cart.item_count);
        showToast('Added to cart!');
        rows.forEach(function(row){
          var qtyInput = row.querySelector('.pdp-variant-qty');
          if (qtyInput) qtyInput.value = 0;
        });
      })
      .catch(function(){
        showToast('Could not add those items — please try again.');
      })
      .finally(function(){
        pdpAddMultiple.disabled = false;
        pdpAddMultiple.textContent = originalText;
      });
    });
  }

  var heroBgPhotos = document.querySelectorAll('.hero-bg-photo');
  if (heroBgPhotos.length > 1) {
    var heroBgIndex = 0;
    setInterval(function(){
      heroBgPhotos[heroBgIndex].classList.remove('active');
      heroBgIndex = (heroBgIndex + 1) % heroBgPhotos.length;
      heroBgPhotos[heroBgIndex].classList.add('active');
    }, 4000);
  }

  var postsScroll = document.getElementById('postsScroll');
  var postsPrev = document.getElementById('postsPrev');
  var postsNext = document.getElementById('postsNext');
  if (postsScroll && postsPrev && postsNext) {
    function postsStep(){
      var card = postsScroll.querySelector('.post');
      return card ? card.getBoundingClientRect().width + 24 : 300;
    }
    postsPrev.addEventListener('click', function(){ postsScroll.scrollBy({ left: -postsStep(), behavior: 'smooth' }); });
    postsNext.addEventListener('click', function(){ postsScroll.scrollBy({ left: postsStep(), behavior: 'smooth' }); });
  }

  var fvTrack = document.getElementById('fvTrack');
  var fvPauseBtn = document.getElementById('fvPauseBtn');
  var fvLightbox = document.getElementById('fvLightbox');
  var fvLightboxStage = document.getElementById('fvLightboxStage');
  var fvLightboxClose = document.getElementById('fvLightboxClose');
  var fvHomeParent = null, fvActiveVideo = null;

  function fvCloseLightbox(){
    if (!fvActiveVideo || !fvHomeParent) return;
    fvActiveVideo.pause();
    fvActiveVideo.muted = true;
    fvActiveVideo.controls = false;
    fvHomeParent.appendChild(fvActiveVideo);
    fvLightbox.classList.remove('show');
    fvActiveVideo = null;
    fvHomeParent = null;
    if (fvTrack) fvTrack.classList.remove('paused');
  }

  if (fvTrack) {
    if (fvPauseBtn) {
      fvPauseBtn.addEventListener('click', function(){
        var paused = fvTrack.classList.toggle('paused');
        fvTrack.querySelectorAll('video').forEach(function(v){
          if (paused) { v.pause(); } else { v.play().catch(function(){}); }
        });
        fvPauseBtn.setAttribute('aria-label', paused ? 'Play videos' : 'Pause videos');
      });
    }
    fvTrack.querySelectorAll('.fv-tile').forEach(function(tile){
      tile.addEventListener('click', function(){
        var video = tile.querySelector('video');
        if (!video || !fvLightbox || !fvLightboxStage) return;
        fvHomeParent = tile;
        fvActiveVideo = video;
        fvLightboxStage.appendChild(video);
        video.muted = false;
        video.controls = true;
        video.play().catch(function(){});
        fvLightbox.classList.add('show');
        fvTrack.classList.add('paused');
      });
    });
  }
  if (fvLightboxClose) fvLightboxClose.addEventListener('click', fvCloseLightbox);
  if (fvLightbox) fvLightbox.addEventListener('click', function(e){ if (e.target === fvLightbox) fvCloseLightbox(); });

  var promoPopup = document.getElementById('promoPopup');
  var promoClose = document.getElementById('promoClose');
  if (promoPopup) {
    var promoSeen = false;
    try { promoSeen = localStorage.getItem('promoSeen') === '1'; } catch (e) {}
    if (!promoSeen) {
      setTimeout(function(){
        promoPopup.classList.add('show');
        promoPopup.setAttribute('aria-hidden', 'false');
      }, 4000);
    }
    function closePromo(){
      promoPopup.classList.remove('show');
      promoPopup.setAttribute('aria-hidden', 'true');
      try { localStorage.setItem('promoSeen', '1'); } catch (e) {}
    }
    if (promoClose) promoClose.addEventListener('click', closePromo);
    promoPopup.addEventListener('click', function(e){ if (e.target === promoPopup) closePromo(); });
    var promoForm = document.getElementById('promoForm');
    if (promoForm && promoForm.querySelector('.promo-code')) {
      try { localStorage.setItem('promoSeen', '1'); } catch (e) {}
    }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(x){
        if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  (function(){
    var fab = document.getElementById('finderOpenBtn');
    var modal = document.getElementById('finderModal');
    if (!fab || !modal) return;
    var closeBtn = document.getElementById('finderClose');
    var backBtn = document.getElementById('finderBack');
    var restartBtn = document.getElementById('finderRestart');
    var steps = modal.querySelectorAll('.finder-step');
    var chosenAge = null, chosenSkill = null;

    function showStep(n){
      steps.forEach(function(s){ s.hidden = s.getAttribute('data-step') !== String(n); });
    }
    function openModal(){
      modal.classList.add('show');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      chosenAge = null; chosenSkill = null;
      showStep(1);
    }
    function closeModal(){
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    fab.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e){ if (e.target === modal) closeModal(); });
    if (backBtn) backBtn.addEventListener('click', function(){ showStep(1); });
    if (restartBtn) restartBtn.addEventListener('click', function(){ chosenAge = null; chosenSkill = null; showStep(1); });

    modal.querySelectorAll('[data-age]').forEach(function(btn){
      btn.addEventListener('click', function(){ chosenAge = btn.getAttribute('data-age'); showStep(2); });
    });

    function renderFinderResults(){
      var results = modal.querySelectorAll('.finder-result');
      var shown = 0;
      results.forEach(function(r){ r.hidden = true; });
      results.forEach(function(r){
        if (shown >= 3) return;
        if (r.getAttribute('data-age') === chosenAge && r.getAttribute('data-skill') === chosenSkill) { r.hidden = false; shown++; }
      });
      if (shown < 3) {
        results.forEach(function(r){
          if (shown >= 3) return;
          if (r.getAttribute('data-age') === chosenAge && r.hidden) { r.hidden = false; shown++; }
        });
      }
      var empty = document.getElementById('finderEmpty');
      if (empty) empty.hidden = shown > 0;
    }

    modal.querySelectorAll('[data-skill]').forEach(function(btn){
      btn.addEventListener('click', function(){
        chosenSkill = btn.getAttribute('data-skill');
        renderFinderResults();
        showStep(3);
      });
    });
  })();
})();
